const TiposPersonalizacion = {
  PREDISENO_SVG: 1,
  BIBLIOTECA_PLANTILLAS: 2,
  COMBO_SVG: 3,
  BIBLIOTECA_PREGUNTAS: 4,
  FAMILIA: 5,
  CHOCOMENSAJE: 6,
  IMAGEN_CLIENTE: 7,
}

const TiposAsociacion = {
  MULTIPLE: 1,
  SINGLE: 2,
}

const getTipoPersonalizacion = idTipo => {
  switch (idTipo) {
    case TiposPersonalizacion.PREDISENO_SVG:
      return {
        id: TiposPersonalizacion.PREDISENO_SVG,
        descripcion: 'Prediseños SVG',
        tipoAsociacion: TiposAsociacion.MULTIPLE,
      }
    case TiposPersonalizacion.BIBLIOTECA_PLANTILLAS:
      return {
        id: TiposPersonalizacion.BIBLIOTECA_PLANTILLAS,
        descripcion: 'Bibliotecas de Plantillas',
        tipoAsociacion: TiposAsociacion.MULTIPLE,
      }
    case TiposPersonalizacion.COMBO_SVG:
      return {
        id: TiposPersonalizacion.COMBO_SVG,
        descripcion: 'Combos SVG',
        tipoAsociacion: TiposAsociacion.MULTIPLE,
      }
    case TiposPersonalizacion.BIBLIOTECA_PREGUNTAS:
      return {
        id: TiposPersonalizacion.BIBLIOTECA_PREGUNTAS,
        descripcion: 'Bibliotecas de Preguntas',
        tipoAsociacion: TiposAsociacion.MULTIPLE,
      }
    case TiposPersonalizacion.FAMILIA:
      return {
        id: TiposPersonalizacion.FAMILIA,
        descripcion: 'Familias',
        tipoAsociacion: TiposAsociacion.MULTIPLE,
      }
    case TiposPersonalizacion.CHOCOMENSAJE:
      return {
        id: TiposPersonalizacion.CHOCOMENSAJE,
        descripcion: 'Chocomensaje',
        tipoAsociacion: TiposAsociacion.SINGLE,
      }
    case TiposPersonalizacion.IMAGEN_CLIENTE:
      return {
        id: TiposPersonalizacion.IMAGEN_CLIENTE,
        descripcion: 'Imagen Cliente',
        tipoAsociacion: TiposAsociacion.SINGLE,
      }
    default:
      return {
        id: null,
        descripcion: null,
        tipoAsociacion: null,
      }
  }
}

const getTiposPersonalizacion = () => {
  const tiposPerso = Object.keys(TiposPersonalizacion).map(key => {
    return getTipoPersonalizacion(TiposPersonalizacion[key])
  })
  return tiposPerso
}

export { TiposPersonalizacion, getTiposPersonalizacion, TiposAsociacion }
